import './MainPageSub01.scss';
import fig_abcd from '../images/home/fig_abef.png'; 
import React, { useEffect } from 'react';
import 'aos/dist/aos.css';
import AOS from 'aos';

const MainPageSub01 = () => {

    //=======================================================================
    return (
        <div className="MainPageSub01">
            <section className='sec-main'>

                <p className="heading-1 title1">
                    01 <span className="i-custom">유형</span>을 찾다.
                </p>

                <section className='sec-sub1'>
    <article className='art-main'>

        {/* 제목 - 위에서 내려오는 애니메이션 */}
        <p className="heading-3 title2" data-aos="fade-down" data-aos-duration="1000">
            유형진단이 우선이다!
        </p>

        {/* 유형 리스트 - 왼쪽에서 등장 */}
        <ul className="type-list">
            <li data-aos="fade-right" data-aos-delay="200"><strong>잡스형</strong> <span>창의적 활동형</span></li>
            <li data-aos="fade-right" data-aos-delay="400"><strong>현대형</strong> <span>관계적 언어형</span></li>
            <li data-aos="fade-right" data-aos-delay="600"><strong>유비형</strong> <span>감상적 예술형</span></li>
            <li data-aos="fade-right" data-aos-delay="800"><strong>노벨형</strong> <span>논리적 사고형</span></li>
        </ul>

        {/* 설명 - 확대되면서 등장 */}
        <section className="description" data-aos="zoom-in" data-aos-delay="1000">
            <p>
                유형진단후대표적으로위4개의유형영역으로분석되어보여지지만, 좀더깊이
                있게 분석해 보면<mark>총 42,467,328개의 세부 유형</mark>으로 분석됩니다. 
                이는, 타고난 선천적 달란트와 후천적으로 개발되고 발달되어지는각각의Factor
                에의해종합적으로 형성되는 것으로써 특히나 명확하게 정립되지 않은 자아/목
                표/대인관계력/가치관 등은 초중고 시기에 어떠한 환경과 경험과 정보흡수 그리
                고어떤누구와소통과교감/공감을나눴는지의여부에 따라 반복되는 변화와 진
                화의 과정을 거쳐 본인의 성격과 성향으로 자리매김을 합니다.
            </p>
            
        </section>

        {/* 두 번째 제목 - 위에서 내려오는 애니메이션 */}
        <p className="heading-3 title2" data-aos="fade-down" data-aos-delay="1200">
            유형분석은 모든 것이 보인다!!
        </p>

        {/* 분석 리스트 - 왼쪽에서 등장 */}
        <ul className="analysis-list">
            <li data-aos="fade-right" data-aos-delay="1400">유형별 <mark>행동 & 언어패턴</mark>이 보입니다.</li>
            <li data-aos="fade-right" data-aos-delay="1600">유형별 <mark>장단점</mark>이 보입니다.</li>
            <li data-aos="fade-right" data-aos-delay="1800">유형별 <mark>우선순위</mark>가 보입니다.</li>
            <li data-aos="fade-right" data-aos-delay="2000">유형별 <mark>진로방향</mark>이 보입니다.</li>
            <li data-aos="fade-right" data-aos-delay="2200">유형별 <mark>진학 & 입시전략</mark>이 보입니다.</li>
            <li data-aos="fade-right" data-aos-delay="2400">유형별 <mark>공부법</mark>이 보입니다.</li>
        </ul>
    </article>

    {/* 이미지 - 오른쪽에서 등장 */}
    <article className='art-main'>
        <img className='img-abcd' src={fig_abcd} alt="유형 분석 이미지" data-aos="fade-left" data-aos-delay="1500"/>
    </article>
</section>


            </section>
        </div>
    );
};

export default MainPageSub01;
